import { FormattedMessage } from "react-intl";

import { useLocalizedHref } from "@/libraries/web-framework/src/localization/use-localized-href";
import { DEFAULT_VALUES } from "@/libraries/web-framework/src/localization/values";

export const FreeAutomationRuleRuns = () => {
    const localizedHref = useLocalizedHref("/software/confluence/automation");
    return (
        <div>
            <p>
                <FormattedMessage
                    id="ConfluencePricingPageTeam24.features.freeAutomationRuleRuns.content.body"
                    defaultMessage="Increase efficiency by replacing manual, time-consuming work with automated processes and workflows. With Free, unlock 10 automation rule runs per instance per month. <a>Learn more.</a>"
                    values={{
                        ...DEFAULT_VALUES,
                        a: (chunks) => (
                            <a
                                data-event="clicked"
                                data-event-component="linkButton"
                                data-product-key="confluence"
                                data-label-english="learn more"
                                data-track-event="ConfluencePricingPageTeam24.freeAutomationRuleRuns.learnMore"
                                data-event-container="ConfluencePriceFinderTeam24"
                                href={localizedHref}
                            >
                                {chunks}
                            </a>
                        )
                    }}
                />
            </p>
        </div>
    );
};

export const StandardAutomationRuleRuns = () => {
    const localizedHref = useLocalizedHref("/software/confluence/automation");
    return (
        <div>
            <p>
                <FormattedMessage
                    id="ConfluencePricingPageTeam24.features.standardAutomationRuleRuns.content.body"
                    defaultMessage="Increase efficiency by replacing manual, time-consuming work with automated processes and workflows. With Standard, unlock 100 automation rule runs per instance per month. <a>Learn more.</a>"
                    values={{
                        ...DEFAULT_VALUES,
                        a: (chunks) => (
                            <a
                                data-event="clicked"
                                data-event-component="linkButton"
                                data-product-key="confluence"
                                data-label-english="learn more"
                                data-track-event="ConfluencePricingPageTeam24.standardAutomationRuleRuns.learnMore"
                                data-event-container="ConfluencePriceFinderTeam24"
                                href={localizedHref}
                            >
                                {chunks}
                            </a>
                        )
                    }}
                />
            </p>
        </div>
    );
};
